import React from "react";
import { Routes, Route } from "react-router-dom";
import EditTerms from "./edit-terms";
import TermsDetail from "./terms-detail";

//
const Terms = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<TermsDetail />} />
         <Route path="/" element={<TermsDetail />} />
         <Route path="/edit" element={<EditTerms />} />
      </Routes>
    </React.Fragment>
  );
};

export default Terms;
